import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { PharmaceuticalForm } from "../../../Data/Art57Data/PharmaceuticalForm";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePharmaceuticalForm extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new PharmaceuticalForm(new FieldDefinition(injector)),
        'Authorised Pharmaceutical form{param}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Authorised Pharmaceutical Form';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
  
      if (this.data && this.data.model &&
        this.data.model.authpharmformcode &&
        this.data.model.authpharmformcode.value) {
          if (this.data.model.authpharmformcode.name) {
            this.label = this.data.model.authpharmformcode.name;                
          }else if (!lazy) { 
            this.ioc!.get(LookupGetService).getLookup('pharmform',this.data.model.authpharmformcode.value)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.authpharmformcode.name = result.name;
                this.refreshLabel();
              } else {
                this.label = this.labelTemplate.replace('{param}', '');
              }
            });
          }   
        } else {
          this.label = this.labelTemplate.replace('{param}', '');
        } 

    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.authpharmformcode
          ? this.data.model.authpharmformcode.value
          : 'Not selected',
        this.data.model && this.data.model.authpharmformcode
          ? this.data.model.authpharmformcode.name
          : 'Pharmaceutical form',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodePharmaceuticalForm = new TreeNodePharmaceuticalForm(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getMessage(): any {
      if (this.data.model && Object.keys(this.data.model).length > 0) {
        return this.data.model;
      } else {
        return;
      }
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
  }

}